import React from 'react';

const OurExpert = ({service}) => {
    const {img, title, name, mail} = service;
    return (
        <div className="card bg-base-100 shadow-xl">
            <figure className="px-10 pt-10">
                <img src={img} alt="Shoes" className="rounded-xl" />
            </figure>
            <div className="card-body items-center text-center">
                <h2 className="card-title">{name}</h2>
                <h2 className="text-xl">{title}</h2>
                <h2 className="">Contact: {mail}</h2>
            </div>
        </div>
    );
};

export default OurExpert;